/* 
  START: you can define custom functions within this area
  v v v v v v v v v v v v v v v v v v v v v v v v v v v
*/

function bindCookiePrefsClick() {
    var cookielink = document.querySelector('a[href="#CookiePreferences"]');
    if (cookielink) {
        cookielink.addEventListener('click', openCookiePrefs, false);
    }
}
function openCookiePrefs(e) {
    e.preventDefault();
    if (typeof OneTrust !== "undefined" && typeof OneTrust.ToggleInfoDisplay === "function") {
        OneTrust.ToggleInfoDisplay();
    } else {
        console.warn('OneTrust is not loaded yet.');
    }
    return false;
}

function lazyLoadVideos() {
  theme.utils.libraryLoader('lozad', theme.libraries.lozad, () => {
    if (typeof lozad !== "undefined"){
      const observer = lozad('.lozad', {
        threshold: 0.1,
        loaded: function(el) {
            if (el.nodeName.toLowerCase() === 'video') {
                if (el.childNodes) {
                    var childs = el.childNodes;
                    for (var i = 1; i < childs.length - 1; i++) {
                        if (childs[i].nodeName.toLowerCase() === 'source') {
                            childs[i].src = childs[i].getAttribute('data-src');
                        }
                    }
                    el.load();
                    el.setAttribute('autoplay', ''); // Or el.autoplay = true;
                }
            }
        }
      });
      observer.observe();
    }
  });
}

/* PLP sticky filter bar */
function initPLPStickyNav() {
  var collectionNavBar = $('.navigation--root[data-sticky="true"]');
  let plpNavTop = collectionNavBar.offset().top;
  
  function plpstickynavbar() {
    //window.console.log('window.scrollY='+window.scrollY+' plpNavTop='+ plpNavTop);
    var annHeight = document.documentElement.style.getPropertyValue('--announcement-height').replace('px', '');
    var hdrHeight = document.documentElement.style.getPropertyValue('--header-height').replace('px', '');
    var scrollTrigger = (window.scrollY + parseInt(annHeight) + parseInt(hdrHeight));
    //window.console.log('scrollTrigger=', scrollTrigger);
    if (scrollTrigger >= plpNavTop) {    
      collectionNavBar.addClass('is-stuck');
    } else {
      collectionNavBar.removeClass('is-stuck');    
    }
  }
  plpstickynavbar();
  window.addEventListener('scroll', plpstickynavbar);
}
/* END: PLP sticky filter bar */


function accessibilityFixes() {
  $('body').on('keydown', 'a, [role="button"]', function(e) {
      if (e.key === ' ') {
        e.preventDefault(); // Prevent default spacebar behavior (scrolling)
        $(this).trigger('click'); // Trigger the button's click event
      }
  });
}

/* set up custom ElevarDataLayer events */
function bindCustomElevarEvents() {

  /** 
   * Optimove in GTM needs a "cart_empty" event
   * sent only when the cart goes from 1 or more to Zero
  */
  window.on('theme:cart:quantityUpdated', ({ detail: data }) => {
    if (data.items_removed && data.items_removed.length) {
      if (data.item_count == 0) {
        window.ElevarDataLayer.push({ event: "cart_empty" });
      }
    }
  });
}

// Shoplift analytics consent sync with OneTrust
function setShopliftConsent() {
  if (typeof window.shoplift?.setAnalyticsConsent === 'function') {
    // Assuming category C0002 is Analytics in your OneTrust setup
    var consentGiven = typeof OneTrustActiveGroups !== 'undefined' && OneTrustActiveGroups.indexOf('C0002') !== -1;

    window.shoplift.setAnalyticsConsent(consentGiven).catch(function (err) {
      console.warn('Failed to set Shoplift analytics consent:', err);
    });
  }
}

// Pass consent selections from OneTrust to Shopify
function listenForConsentUpdates() {
  window.addEventListener("OneTrustGroupsUpdated", otEvent => {
    var shopifyConsentGroups = {
      "analytics": otEvent.detail.includes('C0002'),
      "preferences": otEvent.detail.includes('C0003'),
      "marketing": otEvent.detail.includes('C0004'),
      "sale_of_data": otEvent.detail.includes('C0004')
    };
    window.Shopify.customerPrivacy.setTrackingConsent(shopifyConsentGroups, () => {
      var updatedConsent = window.Shopify.customerPrivacy.currentVisitorConsent(); 
      window.console.log('~~~~updated Shopify Consent', updatedConsent);
    });    
  });
}

/* collection categories nav bar */
function initCollectionCatNav() {
  const catNavs = document.querySelectorAll('.navigation--category-filters.scrollable');
  catNavs.forEach((catNav) => {
    const activeLinks = catNav.querySelectorAll('.collection-nav-category-link.active');
    if (activeLinks.length) {
      catNav.scrollLeft = activeLinks[0].offsetLeft;
    }

    // desktop has arrows
    if (catNav.classList.contains('has-arrows')) {
      const btnPrev = document.querySelector('.navigation--category-filters-prev');
      const btnNext = document.querySelector('.navigation--category-filters-next');
      if (!btnPrev || !btnNext) {
        return;
      }
      
      const isOverflowed = () => {
        const isOverflow = catNav.offsetHeight < catNav.scrollHeight || catNav.offsetWidth < catNav.scrollWidth;
        if (isOverflow) {
          btnPrev.removeAttribute('style');
          btnNext.removeAttribute('style');
        } else {
          btnPrev.style.display = 'none';
          btnNext.style.display = 'none';
        }
      };
      new ResizeObserver(isOverflowed).observe(catNav);

      const doScroll = (shift) => {
        catNav.scrollLeft += shift;
      };
      btnPrev.on('click', e => {
        doScroll(-200);
      });
      btnNext.on('click', e => {
        doScroll(+200);
      });
      
      catNav.on('scroll', e => {
        if (catNav.scrollLeft === 0) {
          // at start
          btnPrev.disabled = true;
          btnNext.disabled = false;
        } else if (Math.floor(catNav.scrollWidth - catNav.scrollLeft) <= catNav.offsetWidth) {
          // at end
          btnPrev.disabled = false;
          btnNext.disabled = true;
        } else {
          // in middle
          btnPrev.disabled = false;
          btnNext.disabled = false;
        }
      });
    }
  });
}

function initFeedbackBarAccessibility() {
  const feedbackBar = document.querySelector('feedback-bar-root');
  if (!feedbackBar) return;

  function getMessageEl() {
    return feedbackBar.querySelector('.feedback-bar--message');
  }

  function ensureCloseButton() {
    const messageEl = getMessageEl();
    if (!messageEl) return;

    let closeButton = messageEl.querySelector('[data-feedback-close]');

    if (!closeButton) {
      closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'feedback-bar--close';
      closeButton.setAttribute('aria-label', 'Dismiss message');
      closeButton.setAttribute('data-feedback-close', '');
      closeButton.textContent = 'Close';

      closeButton.addEventListener('click', function () {
        feedbackBar.setAttribute('data-transition-active', 'false');
        feedbackBar.setAttribute('data-user-dismissed', 'true');
      });

      messageEl.appendChild(closeButton);
    }
  }

  function ensureAccessibleStructure() {
    const messageEl = getMessageEl();
    if (!messageEl) return;

    messageEl.setAttribute('role', 'alert');
    messageEl.setAttribute('aria-atomic', 'true');
    messageEl.setAttribute('tabindex', '-1');
    messageEl.setAttribute('data-feedback-message', '');

    let textEl = messageEl.querySelector('[data-feedback-message-text]');

    if (!textEl) {
      const closeButton = messageEl.querySelector('[data-feedback-close]');
      const text = Array.from(messageEl.childNodes)
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.textContent)
        .join(' ')
        .trim();

      textEl = document.createElement('span');
      textEl.className = 'feedback-bar--message-text';
      textEl.setAttribute('data-feedback-message-text', '');
      textEl.textContent = text;

      messageEl.innerHTML = '';
      messageEl.appendChild(textEl);

      if (closeButton) {
        messageEl.appendChild(closeButton);
      }
    }

    ensureCloseButton();
  }

  ensureAccessibleStructure();

  const observer = new MutationObserver(function (mutations) {
    let shouldFocus = false;

    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        ensureAccessibleStructure();
      }

      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'data-transition-active' &&
        feedbackBar.getAttribute('data-transition-active') === 'true'
      ) {
        feedbackBar.removeAttribute('data-user-dismissed');
        shouldFocus = true;
      }
    });

    if (shouldFocus) {
      const messageEl = getMessageEl();
      if (messageEl) {
        requestAnimationFrame(function () {
          messageEl.focus();
        });
      }
    }
  });

  observer.observe(feedbackBar, {
    attributes: true,
    attributeFilter: ['data-transition-active'],
    childList: true,
    subtree: true
  });
}

function keepFeedbackBarOpenUntilDismissed() {
  const feedbackBar = document.querySelector('feedback-bar-root');
  if (!feedbackBar) return;

  let reopening = false;

  function getMessageText() {
    const textEl = feedbackBar.querySelector('[data-feedback-message-text]');
    if (textEl) return textEl.textContent.trim();

    const messageEl = feedbackBar.querySelector('.feedback-bar--message');
    if (!messageEl) return '';

    return messageEl.textContent.trim();
  }

  function reopenIfNeeded() {
    if (reopening) return;
    if (feedbackBar.getAttribute('data-user-dismissed') === 'true') return;
    if (!getMessageText()) return;

    reopening = true;
    feedbackBar.setAttribute('data-transition-active', 'true');

    requestAnimationFrame(function () {
      reopening = false;
    });
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'data-transition-active'
      ) {
        const isActive = feedbackBar.getAttribute('data-transition-active') === 'true';

        if (!isActive) {
          setTimeout(reopenIfNeeded, 0);
        }
      }

      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        if (
          getMessageText() &&
          feedbackBar.getAttribute('data-user-dismissed') !== 'true'
        ) {
          feedbackBar.setAttribute('data-transition-active', 'true');
        }
      }
    });
  });

  observer.observe(feedbackBar, {
    attributes: true,
    attributeFilter: ['data-transition-active'],
    childList: true,
    characterData: true,
    subtree: true
  });

  feedbackBar.addEventListener('click', function (event) {
    const closeBtn = event.target.closest('[data-feedback-close]');
    if (!closeBtn) return;

    feedbackBar.setAttribute('data-user-dismissed', 'true');
    feedbackBar.setAttribute('data-transition-active', 'false');
  });
}

/* 
  ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
  END: area to define custom functions
  =====================================================
*/


/* 
  jQueryIsReady is just like like $(document).ready() - put your jQuery code here to avoid timing errors
*/
var jQueryIsReady = function() {
  /* 
    START: add any jQuery code or call functions that DEPEND on jQuery within this block
    (don't define functions here, just call them from here)
    v v v v v v v v v v v v v v v v v v v v v v v v v v v
  */

  accessibilityFixes();
  
  if ( $('.navigation--root[data-sticky="true"]').length ) {
     initPLPStickyNav();
  }
  
  /* 
    ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
    END: code that DEPENDS on jQuery goes in the area above
  */
} 
// end jQueryIsReady
// ========================================================================


/* 
  dkCustomInit is a function that runs immediately on page load, 
  but may finish before jQuery is fully loaded
*/
function dkCustomInit() {
  var checkJquery = function(){
    if (typeof jQuery === "undefined"){
        return false;
    } else {
        clearTimeout(jqInterval);
        jQueryIsReady();
    }
  }
  var jqInterval = setInterval(checkJquery,1000);

  /* 
    START: call any functions that DON'T depend on jQuery within this block
    (don't define functions here, just call them from here)
    v v v v v v v v v v v v v v v v v v v v v v v v v v v
  */
 

  // Pass consent selections from OneTrust to Shopify
  listenForConsentUpdates();

  bindCookiePrefsClick();
  bindCustomElevarEvents();

  lazyLoadVideos();
  initCollectionCatNav();

  initFeedbackBarAccessibility();
  keepFeedbackBarOpenUntilDismissed();  

  // Set Shoplift consent when OneTrust is ready
  if (typeof OneTrust !== 'undefined') {
    setShopliftConsent();
    OneTrust.OnConsentChanged(setShopliftConsent);
  } else {
    document.addEventListener('OneTrustGroupsUpdated', setShopliftConsent);
  }  

  
  /* 
    ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
    END: functions that DON'T depend on jQuery
    =====================================================
  */ 
}
// end dkCustomInit
// ========================================================================

// ========================================================================
// Prevent SmartCart from opening when filter drawer is opened
(function waitForSmartCart() {
  if (window.Rebuy && Rebuy.SmartCart && Rebuy.SmartCart.show) {
    const originalShow = Rebuy.SmartCart.show;

    Rebuy.SmartCart.show = function () {
      const layoutvp = document.querySelector('.layout--viewport');
      const view = layoutvp && layoutvp.getAttribute('data-drawer-view');

      // 🚫 Block SmartCart when filter drawer triggered the open
      if (view === 'filter') return;

      return originalShow.apply(this, arguments);
    };
  } else {
    setTimeout(waitForSmartCart, 100);
  }
})();


/* LEAVE THIS AT THE BOTTOM OF THE FILE AND DO NOT EDIT */
if (/complete|interactive|loaded/.test(document.readyState)) {
    dkCustomInit();
} else {
    document.addEventListener('DOMContentLoaded', dkCustomInit);
}